<template>
    <!-- <Breadcrumbs main="Setting" mains="Patient Management" title="Patient Management" /> -->
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Pasien List</h5>
                    <button class="btn btn-primary" @click="openModal()">
                        <i class="fa fa-plus"></i> Add Pasien
                    </button>
                </div>
            </div>
            <div class="card-body">
                <DataTable :headers="headers" :items="patients" :loading="loading" :total="total" :params="params"
                    @update:params="updateParams">
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-warning me-2" @click="editPatient(item as Patient)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-danger" @click="deletePatient(item as Patient)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>
                    <template #item.CreatedAt="{ item }">
                        {{ formatDateTime(item.CreatedAt) }}
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <div class="modal fade bd-example-modal-lg" id="patientModal" tabindex="-1" ref="modalRef"
        aria-labelledby="patientModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <h3 class="modal-header justify-content-center border-0">{{ modalTitle }}</h3>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Informasi</label>
                            <select v-model="form.information" class="form-select">
                                <option :value="null" disabled>Select Informasi</option>
                                <option v-for="option in plaformOptions" :key="option.name" :value="option.name">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Tanggal Interaksi</label>
                            <input class="form-control digits" type="datetime-local" v-model="form.CreatedAt">
                        </div>
                        <div class="col-md-6 mb-3" hidden>
                            <label class="form-label">Code</label>
                            <input v-model="form.code" type="text" class="form-control" disabled>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Nama</label>
                            <input v-model="form.name" type="text" class="form-control" required>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">No Telp</label>
                            <input v-model="form.no_telp" type="text" class="form-control">
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Keluhan</label>
                            <input v-model="form.keluhan" type="text" class="form-control">
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Response Pasien</label>
                            <select v-model="form.response" class="form-select">
                                <option :value="null" disabled>Select Response</option>
                                <option v-for="option in responseOptions" :key="option.name" :value="option.name">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <label class="form-label">Alamat</label>
                            <input v-model="form.address" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Province</label>
                            <select v-model="form.province" class="form-select">
                                <option :value="null" disabled>Select Province</option>
                                <option v-for="option in provinceOptions" :key="option.province"
                                    :value="option.province">
                                    {{ option.province }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label">City</label>
                            <select v-model="form.city" class="form-select">
                                <option :value="null" disabled>Select City</option>
                                <option v-for="option in cityOptions" :key="option.city" :value="option.city">
                                    {{ option.city }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Area</label>
                            <select v-model="form.area" class="form-select">
                                <option :value="null" disabled>Select Area</option>
                                <option v-for="option in areaOptions" :key="option.area" :value="option.area">
                                    {{ option.area }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-danger" type="button" @click="closeModal">Cancel</button>
                    <button class="btn btn-primary" type="submit" @click="savePatient">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, nextTick, watch } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/Datatable.vue'
import { Modal } from 'bootstrap'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const plaformOptions = ref<{ ID: any, name: string }[]>([])
const responseOptions = ref<{ ID: any, name: string }[]>([])


// {{ Define Patient interface }}
interface Patient {
    ID: any; // Allow null for new patients
    code: string;
    name: string;
    no_telp: string;
    keluhan: string;
    address: string;
    response: string;
    province: string;
    city: string;
    area: string;
}

const headers = [
    { text: 'Code', value: 'code' },
    { text: 'Name', value: 'name' },
    { text: 'Telp', value: 'no_telp' },
    { text: 'Address', value: 'address' },
    { text: 'Response', value: 'response' },
    { text: 'Created', value: 'CreatedAt' },
    { text: 'Actions', value: 'actions' }
]

// {{ Apply types to refs and reactive objects }}
const patients = ref<Patient[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    email: session.getUser().email,
    clinic: session.getUser().clinic,
})

const modalTitle = ref('')
const provinceOptions = ref<{ province: string, city: string, area: string }[]>([])
const cityOptions = ref<{ province: string, city: string, area: string }[]>([])
const areaOptions = ref<{ province: string, city: string, area: string }[]>([])

const fetchPlatform = async () => {
    await master.postRequest("/platform/list", { page: 1, size: 10000 }).then((resp) => {
        plaformOptions.value = resp.data
    })
}
const fetchResponse = async () => {
    await master.postRequest("/response-patient/list", { page: 1, size: 10000 }).then((resp) => {
        responseOptions.value = resp.data
    })
}
const form = reactive<any>({
    ID: null,
    clinic: '',
    code: '',
    name: '',
    no_telp: '',
    keluhan: '',
    information: '',
    response: 'Merespon',
    province: null,
    city: null,
    area: null,
    address: '',
    sales_name: '',
    sales_email: '',
    CreatedAt: formatDateTimeLocal(new Date()),

})

// Add this data data array
import * as clinic from "@/api/services/ClinicRequest";
import * as master from "@/api/services/MasterRequest";

const fetchProvince = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await master.postRequest("/destination/province", { page: 1, size: 10000, search: '' });
        provinceOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch patients')
    }
    loading.value = false
}

const fetchCity = async (province: string) => {
    loading.value = true
    try {
        const resp = await master.postRequest("/destination/city", {
            page: 1,
            size: 10000,
            search: province
        });
        cityOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch cities')
    }
    loading.value = false
}

const fetchArea = async (city: string) => {
    loading.value = true
    try {
        const resp = await master.postRequest("/destination/area", {
            page: 1,
            size: 10000,
            search: city
        });
        areaOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch cities')
    }
    loading.value = false
}

const fetchPatient = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const resp = await clinic.postRequest("/patient/list", params);
        patients.value = resp.data
        total.value = resp.total

    } catch (error) {
        toast.error('Failed to fetch patients')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchPatient()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly

// View modal state
const viewModalRef = ref<HTMLElement | null>(null)
let bsViewModal: any | null = null


const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}

const savePatient = async () => {
    const formTemp = { ...form }
    formTemp.clinic = session.getUser().clinic; // <-- Use .value to get the string result
    formTemp.sales_name = session.getUser().nickname;
    formTemp.sales_email = session.getUser().email;
    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        formTemp.CreatedAt = new Date(formTemp.CreatedAt).toISOString()
        if (formTemp.ID) {
            // Update existing patient in data data
            await clinic.postRequest("/patient/update", formTemp).then((resp) => {
                if (resp.status === 200) {
                    toast.success('Patient updated successfully');
                    closeModal();
                    fetchPatient(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to update patient');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to update patient');
            })
        } else {
            // Add new patient to data data
            await clinic.postRequest("/patient/create", formTemp).then((resp) => {
                if (resp.status === 200) {
                    toast.success('Patient created successfully');
                    closeModal();
                    fetchPatient(); // Re-fetch to update the table view
                } else {
                    toast.error('Failed to create patient');
                }
            }).catch((error) => {
                toast.error(error.message || 'Failed to create patient');
            })
        }
    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to save patient');
    } finally {
        loading.value = false; // End loading state
    }
}

// {{ Define editPatient function }}
const editPatient = async (patient: Patient) => {
    openModal(patient); // Call openModal with the medicine data

}


// {{ Add type annotation for patient parameter }}
const deletePatient = async (patient: Patient) => {
    if (!confirm('Are you sure you want to delete this patient?')) return

    loading.value = true; // Indicate loading state
    try {
        // Simulate API call
        await clinic.postRequest("/patient/delete", { ID: patient.ID }).then((resp) => {
            if (resp.status === 200) {
                toast.success('Patient deleted successfully');
                closeModal();
                fetchPatient(); // Re-fetch to update the table view
            } else {
                toast.error('Failed to delete patient');
            }
        })

    } catch (error: any) { // Type error
        toast.error(error.message || 'Failed to delete patient');
    } finally {
        loading.value = false; // End loading state
    }
}

function formatDateTimeLocal(date: any) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

// Update openModal to ensure accounts array exists
const openModal = (patient: any | null = null) => {
    if (patient) {
        modalTitle.value = 'Edit Patient'
        isEditing.value = true; // Stop watchers

        Object.assign(form, patient);
        // Always set current date and time
        form.CreatedAt = formatDateTimeLocal(new Date());
        nextTick(() => {
            // Set Province (string value)
            if (patient.province && provinceOptions.value.length > 0) {
                form.province = provinceOptions.value.find(opt => opt.province === patient.province)?.province || null;
            } else {
                form.province = null;
            }

            // Set City (string value)
            if (patient.city && cityOptions.value.length > 0) {
                form.city = cityOptions.value.find(opt => opt.city === patient.city)?.city || null;
            } else {
                form.city = null;
            }

            // Set Area (string value)
            if (patient.area && areaOptions.value.length > 0) {
                form.area = areaOptions.value.find(opt => opt.area === patient.area)?.area || null;
            } else {
                form.area = null;
            }

            isEditing.value = false; // Re-enable watchers after assignments
        })
    } else {
        modalTitle.value = 'Create Patient'
        Object.keys(form).forEach(key => form[key] = (Array.isArray(form[key]) ? [] : null));
        form.code = '';
        form.name = '';
        form.no_telp = '';
        form.keluhan = '';
        form.response = 'Merespon';
        form.province = null;
        form.city = null;
        form.area = null;
        form.address = '';
        // Set current date and time for new patient
        form.CreatedAt = formatDateTimeLocal(new Date());
    }
    if (bsModal) {
        bsModal.show()
    }
}

const isEditing = ref(false) // Flag to control watcher execution

onMounted(() => {
    fetchPlatform();
    fetchResponse();
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
    if (viewModalRef.value) {
        bsViewModal = new Modal(viewModalRef.value)
    }
    fetchProvince()
    fetchPatient() // Fetch initial patient data
})
// Watch for province changes to fetch cities
watch(() => form.province, (newProvince) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newProvince && newProvince) {
        fetchCity(newProvince)
        form.city = null // reset city selection
        areaOptions.value = []
        form.area = null
    } else {
        cityOptions.value = []
        form.city = null
        areaOptions.value = []
        form.area = null
    }
})

// Watch for city changes to fetch areas
watch(() => form.city, (newCity) => {
    if (isEditing.value) return; // Skip watcher logic during editing
    if (newCity && newCity) {
        fetchArea(newCity)
        form.area = null // reset area selection
    } else {
        areaOptions.value = []
        form.area = null
    }
})

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}
</script>